// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7d2ce72c","453":"b5dd5249","455":"3a97129e"}[chunkId] + ".chunk.js";
};